module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/banner_e7245013dcac3a432f155d6996214eb5.png";